import PropTypes from 'prop-types';

export const sidebarStatePropType = PropTypes.shape({
  isTransitionEntered: PropTypes.bool.isRequired,
});
